import React, { useState } from 'react';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import ReportResult from './report-result';
import ReportForm from './report-form';
const DeviceReportModal = props => {
    const { isReported, deviceMacInfo, onCloseModal, reporting = false, noShowResultInModal = false, onReportSuccess, isLogin = false } = props;
    const [reportResultVisible, setReportResultVisible] = useState(reporting);
    const [changedDeviceInfo, setChangedDeviceInfo] = useState(null);
    const [modalVisible, setModalVisible] = useState(true);
    return (React.createElement(Modal, { footer: null, title: reportResultVisible ? '设备申报结果' : isReported ? '设备信息' : '设备申报', visible: modalVisible, onCancel: () => {
            setModalVisible(false);
            onCloseModal && onCloseModal();
        } }, isReported || reportResultVisible ? (React.createElement(ReportResult, { onCloseModal: () => {
            onCloseModal && onCloseModal();
        }, hideSuccess: reportResultVisible ? false : isReported, deviceMacInfo: changedDeviceInfo || deviceMacInfo })) : (React.createElement(ReportForm, { deviceMacInfo: deviceMacInfo, isLogin: isLogin, onReportSuccess: newDeviceInfo => {
            onReportSuccess && onReportSuccess(newDeviceInfo);
            if (!noShowResultInModal) {
                setReportResultVisible(true);
                setChangedDeviceInfo(newDeviceInfo);
            }
        } }))));
};
export default DeviceReportModal;
